export default __webpack_public_path__ + "static/runners-af64656bf7c2dd50000128d3c9ccafdc.png";